import { syncURLParams } from "./searchHelpers";

export const applyFilterURL = (filters) => {
  const searchParams = new URLSearchParams(window.location.search);

  if (filters.country) {
    searchParams.set("country", filters.country.value);
  } else {
    searchParams.delete("country");
  }
  if (filters.datetime[0]) {
    searchParams.set("from", filters.datetime[0].format("YYYY-MM-DD"));
  } else {
    searchParams.delete("from");
  }

  if (filters.type) {
    searchParams.set("type", filters.type);
  } else {
    searchParams.delete("type");
  }
  
  if (filters.categories.length) {
    searchParams.set("categories", filters.categories.join(","));
  } else {
    searchParams.delete("categories");
  }

  syncURLParams(searchParams);
};

export const displayDate = (startDate, endDate) => {
  let isSameYear = startDate.format("YY") == endDate.format("YY");
  let isSameMonth = startDate.format("M") == endDate.format("M");

  if (isSameMonth) {
    if (isSameYear) {
      return (
        startDate.format("D") +
        " - " +
        endDate.format("D MMM YYYY")
      );
    } else {
      return (
        startDate.format("D MMM YYYY") +
        " - " +
        endDate.format("D MMM YYYY")
      );
    }
  }

  if (isSameYear) {
    return (
      startDate.format("D MMM") +
      " - " +
      endDate.format("D MMM YYYY")
    );
  }
  else {
    return (
      startDate.format("D MMM YYYY") +
      " - " +
      endDate.format("D MMM YYYY")
    );
  }
}